/**
 * Fire an event handler to the specified node. Event handlers can detect that the event was fired programatically
 * by testing for a 'synthetic=true' property on the event object
 * @param {HTMLNode} node The node to fire the event handler on.
 * @param {String} eventName The name of the event without the 'on' (e.g., 'focus')
 */
function fireEvent (node, eventName, args) {
  // Make sure we use the ownerDocument from the provided node to avoid cross-window problems
  let doc
  let event

  if (node.ownerDocument) {
    doc = node.ownerDocument
  } else if (node.nodeType === 9) {
    // the node may be the document itself, nodeType 9 = DOCUMENT_NODE
    doc = node
  } else {
    throw new Error(`Invalid node passed to fireEvent: ${node.id}`)
  }

  if (node.dispatchEvent) {
    // Gecko-style approach (now the standard) takes more work
    let eventClass = ''

    // Different events have different event classes.
    // If this switch statement can't map an eventName to an eventClass,
    // the event firing is going to fail.
    switch (eventName) {
      // Dispatching of 'click' appears to not work correctly in Safari. Use 'mousedown' or 'mouseup' instead.
      case 'click':
      case 'mousedown':
      case 'mouseup':
        eventClass = 'MouseEvents'
        break

      case 'focus':
      case 'change':
      case 'blur':
      case 'select':
      default:
        eventClass = 'HTMLEvents'
        break
    }

    event = doc.createEvent(eventClass)
    var bubbles = eventName !== 'change'
    event.initEvent(eventName, bubbles, true) // All events created as bubbling and cancelable.

    event.synthetic = true // allow detection of synthetic events
    event.args = args
    node.dispatchEvent(event, true)
  } else if (node.fireEvent) {
    // IE-old school style
    event = doc.createEventObject()
    event.synthetic = true // allow detection of synthetic events
    event.args = args
    node.fireEvent('on' + eventName, event)
  }
};

function fire (types, args) {
  types = types.split(' ')

  return this.each(function () {
    types.forEach((type) => {
      fireEvent(this, type, args)
    })
  })
}

export default fire
